module.exports = __webpack_public_path__ + "img/YC-logo.77e4c97f.png";